"use client"

import { Check, X } from "lucide-react"
import { getPasswordStrength, PASSWORD_REGEX } from "@/lib/password-strength"

export const DEFAULT_PASSWORD_LABELS = {
    minLength: "10+ characters",
    uppercase: "Uppercase (A-Z)",
    lowercase: "Lowercase (a-z)",
    number: "Number (0-9)",
    special: "Special char (optional)",
}

export const DEFAULT_PASSWORD_LABELS_RO = {
    minLength: "10+ caractere",
    uppercase: "Literă mare (A-Z)",
    lowercase: "Literă mică (a-z)",
    number: "Cifră (0-9)",
    special: "Caracter special (opțional)",
}

interface PasswordStrengthIndicatorProps {
    value: string
    labels?: {
        minLength: string
        uppercase: string
        lowercase: string
        number: string
        special: string
    }
}

export function PasswordStrengthIndicator({ value, labels = DEFAULT_PASSWORD_LABELS }: PasswordStrengthIndicatorProps) {
    if (!value || value.length === 0) return null

    const { checks, score } = getPasswordStrength(value, labels)
    const strengthColor =
        score <= 2 ? "bg-red-500"
        : score <= 3 ? "bg-orange-500"
        : score <= 4 ? "bg-yellow-500"
        : "bg-green-500"

    return (
        <div className="space-y-2 mt-1">
            <div className="flex gap-1">
                {[1, 2, 3, 4, 5].map((i) => (
                    <div
                        key={i}
                        className={`h-1 flex-1 rounded-full transition-colors ${i <= score ? strengthColor : "bg-muted"}`}
                    />
                ))}
            </div>
            <div className="grid grid-cols-2 gap-x-3 gap-y-0.5">
                {checks.map(({ label, met }) => (
                    <div key={label} className="flex items-center gap-1.5 text-[11px]">
                        {met ? (
                            <Check className="h-3 w-3 text-green-500 flex-shrink-0" />
                        ) : (
                            <X className="h-3 w-3 text-muted-foreground flex-shrink-0" />
                        )}
                        <span className={met ? "text-green-600" : "text-muted-foreground"}>{label}</span>
                    </div>
                ))}
            </div>
        </div>
    )
}

export { PASSWORD_REGEX }
